module.exports = __webpack_public_path__ + "static/img/platformstatus2.23968274.svg";